import React, { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import StyledDialog, { IStyledDialogProps } from "components/dialogs/styledDialog/StyledDialog";
import OmitType from "customTypes/OmitType";
import BuyNowDialogController from "./BuyNowDialogController";
import { IEditionPurchaseLinkConfig } from "models/IAppConfig";
import Spacer from "components/Spacer";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: { minHeight: 225 },
    })
);

interface IProps extends OmitType<IStyledDialogProps, "title"> {
    editionPurchaseLinkConfig: IEditionPurchaseLinkConfig;
    dialogText?: ReactNode;
}

export default function BuyNowDialog(props: IProps) {
    const classes = useStyles();
    const { editionPurchaseLinkConfig, dialogText, ...rest } = props;

    return (
        <StyledDialog title="Select Platform" {...rest}>
            <div className={classes.root}>
                <BuyNowDialogController editionPurchaseLinkConfig={editionPurchaseLinkConfig} />
                <Spacer size={2} />
                {dialogText}
            </div>
        </StyledDialog>
    );
}
